
import subhead from './index.vue'
// 为组件提供 install 方法
subhead.install = function (Vue) {
    Vue.component(subhead.name, subhead)
}
// 导出组件
export default subhead
